<template>
  <div class="shop-intro" :style="{ 'background-image': `url(${cover})` }">
    <div class="shop-intro__card">
      <div class="shop-intro__content">
        <slot name="contact">
          <Contact :shop="value" />
        </slot>
        <div class="shop-intro__text">
          <h1 class="shop-intro__title">{{ $t('shopShort') }}</h1>
          <div class="shop-intro__subtitle">{{ $path('reference.name', value) }}</div>
          <div class="shop-intro__message" v-html="description"></div>
        </div>
        <div class="shop-intro__actions">
          <ButtonComponent
            :label="$t('start')"
            theme="primary"
            :icon="['fal', 'angle-right']"
            class="shop-intro__primary-action"
            @click="$emit('next')"
          />
          <slot name="actions" />
        </div>
      </div>
      <slot name="duedates" className="shop-intro__duedates" />
    </div>
    <div class="shop-intro__overlay"></div>
  </div>
</template>

<script>
import Contact from './Contact.vue'
export default {
  props: {
    value: Object,
  },
  computed: {
    description() {
      return this.value.description || this.$t('shopWelcomeMessage')
    },
    cover() {
      return this.$path('value.cover.url') || this.$path('value.reference.media.cover.0.url')
    },
  },
  components: {
    Contact,
  },
}
</script>

<style lang="scss">
.shop-intro {
  $breakpoint: 500px;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;

  background-size: cover;
  background-position: center;

  padding: var(--shop-spacing);

  @media (max-width: $breakpoint) {
    padding: 0;
  }

  &__overlay {
    flex-grow: 1;
    background-color: css-alpha('shop-overlay-background-color', var(--shop-overlay-alpha));
    backdrop-filter: blur(8px);

    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
  }

  &__card {
    display: flex;
    flex-wrap: wrap;

    z-index: 1;
    background-color: var(--shop-background-color);
    border-radius: calc(var(--border-radius) * 3);
    overflow: hidden;

    & > div {
      padding: calc(var(--shop-spacing) * 1.5);
      flex-grow: 1;
    }

    @media (max-width: $breakpoint) {
      border-radius: 0;
    }
  }

  [data-cta] {
    background-color: transparent;
    color: black;
    border: 1px solid var(--border-color);

    &:hover {
      background-color: rgba(black, 0.05);
    }
  }

  &__title {
    margin-bottom: 0;
    line-height: 1;
  }

  &__subtitle {
    font-weight: normal;
    margin-top: 0.25rem;
    margin-bottom: 1rem;

    font-size: 1rem;
    opacity: 0.8;
  }

  &__message {
    max-width: 50ch;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: var(--shop-spacing);
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;

    .shop-intro__primary-action {
      min-width: 15ch;
    }

    @media (max-width: $breakpoint) {
      flex-direction: column;
    }
  }

  & &__duedates {
    background-color: var(--shop-header-background);
    // max-width: 50ch;

    @media (max-width: $breakpoint) {
      max-width: 100vw;
    }

    .shop-categories__table {
      max-height: 400px;
      overflow-y: auto;

      @include scrollShadow(var(--shop-header-background));

      .shop-categories__table-header {
        position: sticky;
        top: 0;
        z-index: 1;
        background-color: var(--shop-header-background);
      }
    }
  }
}
</style>
